import { Controller } from "@hotwired/stimulus"
import { setTheme, getTheme } from "../theme"

export default class extends Controller {
  static targets = ["label"]

  connect() {
    this._update = this.update.bind(this)
    this.update()
    document.addEventListener('yqa:theme-change', this._update)
  }

  disconnect() {
    document.removeEventListener('yqa:theme-change', this._update)
  }

  select(event) {
    setTheme(event.currentTarget.dataset.themeValue)
  }

  update() {
    const active = getTheme()
    this.element.querySelectorAll('[data-theme-value]').forEach(el => {
      el.classList.toggle('theme-btn--active', el.dataset.themeValue === active)
    })
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = active.charAt(0).toUpperCase() + active.slice(1)
    }
  }
}
